import { render, staticRenderFns } from "./uav.vue?vue&type=template&id=9502b63e&scoped=true&"
import script from "./uav.vue?vue&type=script&lang=js&"
export * from "./uav.vue?vue&type=script&lang=js&"
import style0 from "./uav.vue?vue&type=style&index=0&id=9502b63e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9502b63e",
  null
  
)

export default component.exports